import { validateConcurrentSession } from '../services/reportServices';  
  
export const validateConcurrentSessionIfEnabled = async () => {  
  try {  
    const isConcurrentSessionEnabled = localStorage.getItem("isConcurrentSessionEnabled");  
    if (isConcurrentSessionEnabled === "true") {  
      const validateSession = await validateConcurrentSession();  
      return validateSession;  
    }  
    return true; // If concurrent session is not enabled, allow the action  
  } catch (error) {  
    console.error("Error validating concurrent session:", error);  
    return false; // Block the action on error  
  }  
};